var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDdxTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 16,
    viewBox: "0 0 36 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 16,
    rx: 4,
    fill: "url(#paint0_linear_262_32734)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.756 3.624C10.636 3.624 11.408 3.796 12.072 4.14C12.744 4.484 13.26 4.976 13.62 5.616C13.988 6.248 14.172 6.984 14.172 7.824C14.172 8.664 13.988 9.4 13.62 10.032C13.26 10.656 12.744 11.14 12.072 11.484C11.408 11.828 10.636 12 9.756 12H6.828V3.624H9.756ZM9.696 10.572C10.576 10.572 11.256 10.332 11.736 9.852C12.216 9.372 12.456 8.696 12.456 7.824C12.456 6.952 12.216 6.272 11.736 5.784C11.256 5.288 10.576 5.04 9.696 5.04H8.508V10.572H9.696ZM18.3576 3.624C19.2376 3.624 20.0096 3.796 20.6736 4.14C21.3456 4.484 21.8616 4.976 22.2216 5.616C22.5896 6.248 22.7736 6.984 22.7736 7.824C22.7736 8.664 22.5896 9.4 22.2216 10.032C21.8616 10.656 21.3456 11.14 20.6736 11.484C20.0096 11.828 19.2376 12 18.3576 12H15.4296V3.624H18.3576ZM18.2976 10.572C19.1776 10.572 19.8576 10.332 20.3376 9.852C20.8176 9.372 21.0576 8.696 21.0576 7.824C21.0576 6.952 20.8176 6.272 20.3376 5.784C19.8576 5.288 19.1776 5.04 18.2976 5.04H17.1096V10.572H18.2976ZM27.7031 12L26.3351 9.936L25.1231 12H23.3231L25.4951 8.664L23.2991 5.352H25.1951L26.5511 7.404L27.7751 5.352H29.5751L27.3911 8.664L29.5991 12H27.7031Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_262_32734",
    x1: 4.23529,
    y1: -1.40246e-8,
    x2: 36.3592,
    y2: 15.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A461D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#B85DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7700D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxTag);
export default __webpack_public_path__ + "static/media/ddx-tag.f6b17b7579cd6cad7e2c1cb664b3f9ab.svg";
export { ForwardRef as ReactComponent };